import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PortChargesService } from 'src/app/services/payments/port-charges.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';

@Component({
  selector: 'app-pay-port-charges',
  templateUrl: './pay-port-charges.component.html',
  styleUrls: ['./pay-port-charges.component.css']
})
export class PayPortChargesComponent implements OnInit{
  payPortCharges!: FormGroup;
  public invoiceId: string | null = null;
  public invoiceData:any;
  showExRate: boolean = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  submitted: boolean = false;
  isProcessing: boolean = false;
  fileName: string="Choose an image or a PDF file";
  attachment: any;

  constructor(
    private formBuilder: FormBuilder,
    private portChargesService:PortChargesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService
  ){
    this.payPortCharges = this.formBuilder.group({
      bl_no: [''],
      no_of_units: [''],
      invoice_no: [''],
      amt_kes: ['', Validators.required],
      amt_usd: ['', Validators.required],
      currency:['', Validators.required],
      ex_rate: [''],
      pmt_mode: ['', Validators.required],
      pmt_ref: ['', Validators.required],
      pmt_date: ['', Validators.required],
      attachment: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.invoiceId = param['get']('invoice_id')
    })

    if(this.invoiceId){
      this.fetchInvoiceData(this.invoiceId);
    }else{
      //Navigate back to invoices list with error
      this.globalService.setGlobalErrorMessage("Unable to select port charges invoice for payment. Please try again!");
      this.router.navigate(['port-charges-invoices']);
    }
  }

   /**
   * Get invoice data
   * @param invoiceId 
   */
   fetchInvoiceData(invoiceId: string): void {
    this.portChargesService.getOpenPortInvoiceDetails(invoiceId)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.invoiceData = response;
          if(this.invoiceData.status==='no_data' || this.invoiceData.status.length===0){
            this.errorMessage=this.invoiceData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  /**
   * Show Exchange rate field if USD is selected
   * and hide if KES or another option is selected
   */
  onDropdownChange(event: any) {
    const selectedOption = event.target as HTMLInputElement;

    if(selectedOption.value!=='' && selectedOption.value!==undefined){
      this.errorMessage=null; //Clear error message if any

      if(selectedOption.value=='USD'){
        this.showExRate=true;
      }else{
        this.showExRate=false;
      }
    }else{
      this.errorMessage="Invalid currency selection!";
    }
  }

  /**
   * Handle selectd file
   * @param event 
   */
  onFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.fileName = fileInput.files?.[0]?.name ?? 'Choose an image or a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.attachment = file
    }
  }

  handleSubmit():void {
    this.submitted = true;
    this.isProcessing = true;

    if(this.payPortCharges.valid) {
      if(this.invoiceId==null || this.invoiceId==undefined || this.invoiceId==''){
        this.globalService.setGlobalErrorMessage("Invalid invoice selected. Please try again. (Missing: Invoice ID)");
        this.router.navigate(['port-charges-invoices']);
      }else if(this.payPortCharges.value.bl_no==null || this.payPortCharges.value.bl_no==undefined || this.payPortCharges.value.bl_no==''){
        this.globalService.setGlobalErrorMessage("Unable to post payment. Please try again. (Missing: BL No.)");
        this.router.navigate(['port-charges-invoices']);
      }else if(this.payPortCharges.value.invoice_no==null || this.payPortCharges.value.invoice_no==undefined || this.payPortCharges.value.invoice_no==''){
        this.globalService.setGlobalErrorMessage("Unable to post payment. Please try again. (Missing: Invoice No.)");
        this.router.navigate(['port-charges-invoices']);
      }else if(this.payPortCharges.value.currency=='USD' && (this.payPortCharges.value.ex_rate==undefined || this.payPortCharges.value.ex_rate=='')){
        this.globalService.setGlobalErrorMessage("Please enter exchange rate!");
        this.isProcessing = false;
      }else if(this.payPortCharges.value.currency=='USD' && Number.isNaN(Number(String(this.payPortCharges.value.ex_rate).replace(",","")))){
        this.errorMessage="Only numbers are acceptable in Exchange Rate field!";
        this.isProcessing = false;
      }else{
        this.portChargesService.payPortCharges(this.payPortCharges.value,this.attachment)
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.submitted = false;
              this.isProcessing = false;
              this.errorMessage=null;
              this.globalService.setGlobalSuccessMessage(response.message);
              this.router.navigate(['port-charges-invoices']);
            }else if(response.status==='warning'){
              this.submitted = false;
              this.isProcessing = false;
              this.errorMessage=null;
              this.globalService.setGlobalWarningMessage(response.message);
              this.router.navigate(['port-charges-invoices']);
            }else{
              this.errorMessage=response.message;
              this.submitted = false;
              this.isProcessing = false;
              this.successMessage=null;
            }
          },
          error: (error) => {
            this.errorMessage=error;
            this.successMessage=null;
            this.submitted = false;
            this.isProcessing = false;
          }
        });
      }
    }else{
      this.isProcessing = false;
    }
  }

}
